/** Shared tooltip system — types used by the runtime, the admin editor and the DB rows. */

export type TooltipSide = "top" | "bottom" | "left" | "right";
export type TooltipAlign = "start" | "center" | "end";

/**
 * Optional scripted step transition, ported from the original Clip Studio tour:
 * click a sub-panel toggle and/or open/close the settings panel, let React
 * paint, then advance to the next step.
 */
export type TooltipNextAction = {
  /** Clicks `[data-tour-open="<key>"]`. */
  click?: string;
  /** Toggle anchored at `[data-tour="<key>"]` whose aria-expanded we drive. */
  expandKey?: string;
  expand?: "open" | "close";
  delayMs?: number;
};

export type TooltipRow = {
  id: string;
  group_id: string;
  anchor_key: string;
  selector: string | null;
  title: string;
  description: string;
  side: TooltipSide;
  align: TooltipAlign;
  sort_order: number;
  is_enabled: boolean;
  next_action: TooltipNextAction | null;
};

export type TooltipGroupRow = {
  id: string;
  key: string;
  name: string;
  description: string | null;
  route_prefix: string | null;
  is_enabled: boolean;
  tour_enabled: boolean;
  tips_enabled: boolean;
  sort_order: number;
};

/** Resolve a tip to a DOM selector — admin override first, anchor key otherwise. */
export function tooltipSelector(t: Pick<TooltipRow, "anchor_key" | "selector">): string {
  return t.selector?.trim() || `[data-tour="${t.anchor_key}"]`;
}
